module.exports = __webpack_public_path__ + "static/media/weather-image.3745c6e5.png";